import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";

// Pages
import HomePage from "./pages/Home";
import MantrailingPage from "./pages/Mantrailing";
import GalleryPage from "./pages/Gallery";
import ContactPage from "./pages/Contact";
import CartPage from "./pages/CartView";
import CheckoutSuccessPage from "./pages/CheckoutSuccess";
import FAQPage from "./pages/FAQ";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import TermsOfServicePage from "./pages/TermsOfService";
import AdminDashboard from "./pages/AdminPanel";
import GiftVouchersPage from "./pages/GiftVouchers";
import GiftVoucherSuccessPage from "./pages/GiftVoucherSuccess";
import AreaLandingPage from "./pages/AreaLanding";

// Scroll to top on route change, or scroll to hash element
const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    
    useEffect(() => {
        if (hash) {
            // If there's a hash, scroll to that element after a short delay
            setTimeout(() => {
                const element = document.getElementById(hash.slice(1));
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
        } else {
            // No hash - scroll to top
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);
    
    return null;
};

// Layout wrapper to conditionally show Navbar/Footer
const Layout = ({ children }) => {
    const location = useLocation();
    const isAdminPage = location.pathname === '/admin';
    
    return (
        <div className="flex flex-col min-h-screen">
            {!isAdminPage && <Navbar />}
            <main className="flex-1">
                {children}
            </main>
            {!isAdminPage && <Footer />}
        </div>
    );
};

function App() {
    return (
        <HelmetProvider>
            <CartProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Layout>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/mantrailing" element={<MantrailingPage />} />
                            <Route path="/gallery" element={<GalleryPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="/cart" element={<CartPage />} />
                            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                            <Route path="/faq" element={<FAQPage />} />
                            <Route path="/privacy" element={<PrivacyPolicyPage />} />
                            <Route path="/terms" element={<TermsOfServicePage />} />
                            <Route path="/gift-vouchers" element={<GiftVouchersPage />} />
                            <Route path="/gift-voucher/success" element={<GiftVoucherSuccessPage />} />
                            <Route path="/mantrailing-near/:area" element={<AreaLandingPage />} />
                            <Route path="/admin" element={<AdminDashboard />} />
                        </Routes>
                    </Layout>
                    <Toaster position="top-right" richColors />
                </BrowserRouter>
            </CartProvider>
        </HelmetProvider>
    );
}

export default App;
